import { useEffect } from 'react';
import { isOfflineEnabled } from '../db/odin-db-util';
import { useAppDispatch } from '../redux/hooks';
import { networkOnline } from '../redux/middleware/offline-mutations.thunk';
import { onlineStatusService } from '../services/online-status.service';

/**
 * Hook that bridges the OnlineStatusService with Redux.
 *
 * It listens for online status changes and dispatches the 'network/online' action
 * to trigger offline synchronization.
 *
 * Note: onlineStatusService.subscribe() fires immediately with the current status,
 * so this will also trigger a sync on app mount if the user is online.
 */
const useOfflineSync = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isOfflineEnabled) {
      return;
    }

    const unsubscribe = onlineStatusService.subscribe((isOnline: boolean) => {
      if (isOnline) {
        dispatch(networkOnline());
      }
    });

    return unsubscribe;
  }, [dispatch]);
};

export default useOfflineSync;
